export default __webpack_public_path__ + "static/media/goods16.7f2cf14f.gif";